import Operation from './Operation.js';

class AddEvent extends Operation {
    constructor(mix, event, time, trackStep) {
        super(mix, event.getType());

        this.event = event;
        this.time = time;
        this.trackStep = trackStep;
    }

    get events() {
        return this.mixByType.events;
    }

    set events(x) {
        this.mixByType.events = x;
    }

    get counter() {
        return this.mixByType.counter;
    }

    set counter(x) {
        this.mixByType.counter = x;
    }

    execute() {
        this.event.setTime(this.time, this.trackStep);

        if (this.events.length == 0 ||
            this.events[this.events.length - 1].step <= this.trackStep) {
            // we don't need to binary search since we're past the last step anyway
            this.events.push(this.event);
            return;
        }

        // binary search the step, to insert at the right sorted spot
        let left = 0;
        let right = this.events.length - 1;

        let middle = undefined;
        while (left <= right) {
            middle = Math.floor((left + right) / 2);
            if (this.events[middle].step < this.trackStep) {
                left = middle + 1;
            } else if (this.events[middle].step > this.trackStep) {
                right = middle - 1;
            } else {
                break;
            }

            if (middle >= 1 &&
                this.events[middle - 1].step <= this.trackStep &&
                this.events[middle].step >= this.trackStep) {
                break;
            }
        }

        if (this.events[middle].step === this.trackStep) {
            // replace that event with this
            this.events[middle] = this.event;
        } else {
            this.events = this.events.slice(0, middle).concat([this.event])
                .concat(this.events.slice(middle));
        }

        this.counter = middle;

        this.event.subSequence = this.mix.subSequence;
    }
}

export default AddEvent;
